export default __webpack_public_path__ + "static/media/v2.e154fa24.jpg";